import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream to-ivory">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <h3 className="text-xl font-playfair font-semibold text-gold mb-2">
          Loading...
        </h3>
        <p className="text-gray-600 font-poppins">
          Preparing your elegant jewellery experience
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
